<template>
    <div class="elementsmegamenu" @mouseleave="handleMouseLeave" >

    <div class="row pt-2 pb-2 d-xl-none">

        <!-- <div class="col-3 text-center" >

                Shop   
        </div> -->

        <div class="col-2 pl-2 text-left">
            <img  alt="" width="30px" class="d-xl-none" src="@/assets/icons/arrow-left.svg" style="cursor: pointer; " 
            @click="hideMobileMenu()"  />  
        </div>

        <div class="col-5 pr-2 pl-0 my-auto text-center"  v-for="(item, index) of filteredHorizontalMenuItems" :key="index">
            <a class="text-dark font-weight-normal p-2 bg-light" style="display:block;" :href="item.link ? item.link : 'javascript:void(0);'">
                            <img v-if="item.icon" width="18px" class="mr-2" :src="require('@/assets/icons/' + item.icon)" />
                            <span class="my-auto font-weight-bold p-0 m-0 h-100">{{ $t(item.label) }}    </span>
                
            </a>
        </div>

        <!-- <div class="col-2 text-right">
            <img class="ml-2 mr-2 " alt=""
                  :src="require('@/assets/images/fi-rr-cross-small.svg')"
                  @click="hideMobileMenu()" />
        </div> -->
    </div>

    <div class="row mb-4 d-xl-none"> 
            <div v-for="(section) in allSections" :key="section.id" class="col-3 pt-2 pb-2  text-center "  style="border-top:1px solid #ddd; cursor:pointer"
            :style="section.id === mainSection.id ? 'border-bottom:2px solid #121212; font-weight:bold;' : 'border-bottom:1px solid #ddd;'"
            @click="chooseSection(section.id); ">
                <span class=" font-size-14">{{ section ? section.name : '' }}</span>
        </div>
    </div>

    <div class="main-padding row">

        <div v-if="isMobile && showSubGroups" class="col-2 d-xl-none ">
            <img  v-if="showSubGroups"  alt="" width="35px" class="bg-dark p-2" src="@/assets/icons/arrow-left-white.svg" style="cursor: pointer; " 
            @click="showSubGroups=false "  />  
        </div>

        <ul v-if="!isMobile || !showSubGroups" class="main col-12 col-md-6 col-xl-2 pr-4">
            <h5 class="mb-4 text-uppercase text-dark">{{ mainSection.name }}</h5>
            
            <simplebar ref="simplebarGroup"  class="pb-4 group-menu-height" >

                <li v-for="(group, index) in mainSection.groups" :key="index" class=" menu-item" >
                    
                    <div class="menu-item-selectable" :class="group.id == mainGroup.id ? 'menu-item-selected' : ''" @click="selectGroup(group.id)"  @mouseover="selectGroupMouseOver(group.id)">
                        <span class="text-uppercase">{{ group ? group.name : '' }}</span> 
                        <img src="../assets/images/arrow-right.svg" alt="Right Arrow" class="arrow-icon ml-2">
                    </div>
                    
                </li>
            </simplebar>
            <li class="text-left text-xl-center " style="color:#c4c4c4;cursor: pointer;" @click="scrollGroupsDown()">
                <img style="width:18px;" class="col-1 iconAngle mt-2" src="../assets/icons/fi-rr-angle-double-small-right.svg" />

            </li>
        </ul>





        <ul v-if="!isMobile || showSubGroups" class=" main col-10 col-md-6 col-xl-2 ">
            <h5 v-if="mainGroup" class="mb-4 text-uppercase text-dark">{{ mainGroup.name }}</h5>
            <simplebar ref="simplebarSubGroup" v-if="subGroups && mainGroup && mainSection" class="group-menu-height" >
                <li>
                    
                        <span class="text-uppercase w-100 menu-item">
                            <a class="menu-link" :href="'/catalogue/'+ mainSection.seoName + '/' + mainGroup.seoName ">
                                Voir Tout
                            </a>
                        </span>
                    
                </li>
                <li v-for="subGroup in subGroups" :key="subGroup.id" class="menu-item">
                    <span class="text-uppercase ">
                        <a class="menu-link" :href="'/catalogue/'+ mainSection.seoName + '/' + mainGroup.seoName + '/' + subGroup.seoName ">
                            {{ subGroup ? subGroup.name : '' }}
                        </a>
                    </span>
                    <img src="../assets/images/arrow-right.svg" alt="Right Arrow" class="arrow-icon">
                </li>

                
            </simplebar>
            <li class="text-left text-xl-center  d-xl-none" style="color:#c4c4c4;cursor: pointer;" @click="scrollSubGroupsDown()">
                    <img style="width:18px;" class="col-1 iconAngle mt-2" src="../assets/icons/fi-rr-angle-double-small-right.svg" />
                </li>
        </ul>


        <ul class=" main col-12 col-xl-2 pr-4 mt-2 mt-xl-0 border-top-mobile ">
            <h5 class="mb-4 mt-4 mt-xl-0 text-uppercase text-dark">Spécial {{ mainSection.name }}</h5>
            
            <simplebar  class="group-menu-height"  >

                <li v-for="(group, index) in specialGroups" :key="index" class=" menu-item" >
                    
                    <div class="menu-item-selectable" :class="group.id == mainGroup.id ? 'menu-item-selected' : ''"  >
                        
                            <span class="text-uppercase"><a :href="group ? '/ha/' + group.seoName : null">{{ group ? group.name : '' }} </a></span>
                       
                        
                    </div>
                    
                </li>
            </simplebar>
            
        </ul>


        <!-- <ul class=" main col-2">
            <li v-for="index in computedSecondRange" :key="index" class=" menu-item">
                <span>{{ subcategories[index] ? subcategories[index].name : '' }}</span>
                <img src="../assets/images/arrow-right.svg" alt="Right Arrow" class="arrow-icon">
            </li>
        </ul>

        <ul class=" main col-2">
            <li v-for="index in computedThirdRange" :key="index" class=" menu-item">
                <span>{{ subcategories[index] ? subcategories[index].name : '' }}</span>
                <img src="../assets/images/arrow-right.svg" alt="Right Arrow" class="arrow-icon">
            </li>
        </ul> -->

        <div v-for="i in Math.max(3 - otherSections.length, 0)" :key="otherSections.length + i - 1" class="col-2 d-none d-xl-flex text-center" style="overflow: hidden; width:274px; height:320px;">
        </div>

        <div v-for="(section) in otherSections.slice(0)" :key="section.id" class="col-2 d-none d-xl-flex text-center " style="overflow: hidden;padding-bottom:40px;"
            @click="chooseSection(section.id); ">
                <img class="piecescategory-img" width="274" height="320" :alt="''" :src="`/api/image/get/`+section.image"  :class="mainSection.id != section.id ? 'inactive-image' :'active-image'" />
                <div class="django piecescategory-tag">{{ section ? section.name : '' }}</div>
        </div>





    </div>
    </div>
</template>


<script >
import simplebar from "simplebar-vue";
import SpecialGroupApi from "@/services/specialGroup-api";
import { horizontalMenuItems } from "./horizontal-menu";


export default ({
    name: "ElementsMegaMenu",
    components: {
        simplebar
    },
    mounted() {

        this.mainCategories= this.menuItems;
        this.categories = this.menuItems[0].groups 
        this.findAllSpecialGroup(this.$store.state.mainSectionId);

    },
    computed: {
        /*computedFirstRange() {
            return Array.from({ length: 5 }, (_, i) => i);
        },
        computedSecondRange() {
            return Array.from({ length: 5 }, (_, i) => i + 5);
        },
        computedThirdRange() {
            return Array.from({ length: 5 }, (_, i) => i + 10);
        },*/

        menuItems() {
            return this.$store.state.menuItems;
        },

        mainSection() {
            let ms = this.$store.state.menuItems.find(section => section.id == this.$store.state.mainSectionId);
            if (!ms) {
                return this.$store.state.menuItems[0];
            }

            return ms;
        },

        allSections() {
            return this.$store.state.menuItems; 
        },

        otherSections() {
            return this.$store.state.menuItems.filter(section => section.id != this.$store.state.mainSectionId)
            .slice(0, 3); //slice to limit the result to 3 in all cases
        },

        mainGroup() {
            const grp = this.mainSection.groups.find(group => group.id == this.selectedGroupId);
            return grp ? grp : this.mainSection.groups[0];
        },

        subGroups() {
            return this.mainGroup ? this.mainGroup.subGroups : [];
        },

        filteredHorizontalMenuItems() {
            return this.horizontalMenuItems.filter(item => (item.id != 9 && item.id !=1) ).slice(0,2);
        },

        isMobile() {
            return window.matchMedia("(max-width: 1199px)").matches;
        },
    },


    watch : {

        showSubGroups(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.scrollSubGroupsTop();
                });
            }
        }
    },

    data() {
        return {
            selectedGroupId: null,
            specialGroups: [],

            horizontalMenuItems: horizontalMenuItems,
            showSubGroups: false,
        }
    },
    methods: {


        handleMouseLeave() {

            if (this.isMobile) {
                return;
            }

            this.$emit('close');
        },
       
        chooseSection(sectionId) {
            this.$store.commit('setMainSectionId', sectionId);
            this.findAllSpecialGroup(sectionId);
        },

        selectGroup(selectedGroupId) {
            this.selectedGroupId = selectedGroupId;
            this.showSubGroups = true;
            //this.scrollSubGroupsTop();
        },

        selectGroupMouseOver(selectedGroupId) {

            if (this.isMobile) {
                return;
            }

            this.selectGroup(selectedGroupId)
        },

        findAllSpecialGroup(sectionId){
            SpecialGroupApi.findAllSpecialGroup(sectionId)
            .then(result => {
            if(result){
                this.specialGroups = result;
            }
            })
        },

        scrollGroupsDown() {
            const simplebar = this.$refs.simplebarGroup.SimpleBar;
            if (simplebar) {
                const scrollElement = simplebar.getScrollElement();
                const currentScrollTop = scrollElement.scrollTop;
                const newScrollTop = currentScrollTop + 100;

                const contentHeight = simplebar.getContentElement().scrollHeight;
                const maxScrollTop = contentHeight - scrollElement.clientHeight;

                const finalScrollTop = Math.min(newScrollTop, maxScrollTop);
                scrollElement.scrollTo({
                    top: finalScrollTop,
                    behavior: 'smooth'
                });
            } 
        },

        scrollSubGroupsDown() {
            const simplebar = this.$refs.simplebarSubGroup.SimpleBar;
            if (simplebar) {
                const scrollElement = simplebar.getScrollElement();
                const currentScrollTop = scrollElement.scrollTop;
                const newScrollTop = currentScrollTop + 100;

                const contentHeight = simplebar.getContentElement().scrollHeight;
                const maxScrollTop = contentHeight - scrollElement.clientHeight;

                const finalScrollTop = Math.min(newScrollTop, maxScrollTop);
                scrollElement.scrollTo({
                    top: finalScrollTop,
                    behavior: 'smooth'
                });
            } 
        },

        scrollSubGroupsTop() {
            const simplebar = this.$refs.simplebarSubGroup.SimpleBar;
            
            if (simplebar) {
                const scrollElement = simplebar.getScrollElement();
 
                scrollElement.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        },

        hideMobileMenu() {
            this.$emit('close');
        }
    }
})
</script>
  
<style scoped>



.simplebar-scrollbar {
    opacity: 1 !important;
    visibility: visible !important;
    display: block !important;
}




@media (min-width: 1200px) {
    .elementsmegamenu {
        /*padding-bottom: 25px;*/
        position:relative;
        background-color: #fff;
        box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.04);
        width: 100%;
        height: 46%;
        overflow: hidden;
        text-align: left;
        font-size: 14px;
        color: #121212;
        font-family: 'Space Grotesk';
        /*padding-top: 4%;
        padding-left: 4%;*/
        z-index: 999999;
    }
}


@media (max-width: 1199px) {
    .elementsmegamenu {
        position: fixed; 
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        overflow: auto !important;

        background-color: #fff;
        text-align: left;
        font-size: 14px;
        color: #121212;
        font-family: 'Space Grotesk';
        /*padding-top: 4%;
        padding-left: 4%;*/
        z-index: 99999999;
    }

    .group-menu-height {
        min-height:17em !important;
        max-height:17em !important;
        overflow-x:hidden !important;
        overflow-y: auto !important;
    }

    .border-top-mobile  {
        border-top: 1px solid #ddd;
    }

    .main-padding {
        padding-top: 4%;
        padding-left: 4%;
        padding-right: 4%;
    }
}

@media (min-width: 1200px) {
    .group-menu-height {
        min-height:23em;
        max-height:23em;  
        overflow-x:hidden;
        overflow-y:auto;
    }
}


.main {
    list-style: none;
    padding: 0;
}

.main-padding {
    padding-top: 4%;
    padding-left: 4%;
}

.menu-item {
    margin-bottom: 18px;
    display: flex;
    align-items: center;
}

.menu-link {
    color: #121212 !important;
}

.menu-link:hover {
    border-bottom: 2px solid #000;
}

.menu-item-selectable {
    cursor: pointer;
}

.menu-item span {
    display: inline-block;
}

.arrow-icon {
    display: none;
}

.menu-item-selectable:hover span {
    border-bottom: 2px solid #000;
}

.menu-item-selectable span {
    border-bottom: 2px solid #fff;
}

.menu-item-selectable:hover .arrow-icon {
    display: inline-block;
}

.menu-item-selected .arrow-icon {
    display: inline-block;
}

.menu-item-selected span {
    border-bottom: 2px solid #000;
}

.django {
    position: relative;
    letter-spacing: -0.4px;
    line-height: 28px;
    font-weight: 500;
    display: inline-block;
    width: 150px;
}

.piecescategory-tag {
    position: absolute;
    /*top: 50%;*/
    left: 50%;
    top: calc(70% - 10%);
    transform: translate(-50%, -50%);
    border-radius: 6px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4px;
    box-sizing: border-box;
    cursor: pointer;
}

.piecescategory-img {
    cursor: pointer;
    padding: 1.9em;
    width: 100%;       
    height: auto;     
    object-fit: cover;
}


.inactive-image {
   /*filter: sepia(70%);*/
   /*filter: grayscale(100%) blur(4px);*/
   /*filter: grayscale(100%);*/
   /*filter: grayscale(100%);*/
   filter: opacity(70%);/* sepia(30%);*/
}


.inactive-image:hover {
    filter: opacity(100%) !important;
}
.active-image {
    /*transform: scale(1.05);*/
}


.iconAngle {
    transform: rotate(90deg);
}


</style>
  